<!-- #166 -->
<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        SKU List
      </div>
      <v-spacer></v-spacer>
    </div>
    <v-divider class="mt-0 mb-4"></v-divider>
    <v-app>
      <v-data-table
        :headers="_headers"
        :items="list"
        :options.sync="options"
        :server-items-length="total"
        :loading="loader"
        class="elevation-1"
        :footer-props="{
          itemsPerPageOptions: [25, 50, 100, 250],
          showFirstLastPage: true,
          firstIcon: 'mdi-arrow-collapse-left',
          lastIcon: 'mdi-arrow-collapse-right',
          prevIcon: 'mdi-minus',
          nextIcon: 'mdi-plus',
        }"
      >
        <template v-slot:top>
          <template>
            <div class="custom-row p-5">
              <v-col
                cols="12"
                sm="3"
                md="3"
                class="pb-0"
                v-if="
                  userCategory.user_category === 3 ||
                  userCategory.user_category === 6
                "
              >
                <v-autocomplete
                  v-model="selectedClient"
                  :items="clients"
                  :loading="clientLoader"
                  hide-no-data
                  item-text="name"
                  item-value="id"
                  label="Select Client"
                  placeholder="Start typing to Search"
                  class="pb-2 pt-0 text-center"
                  @focus="fetchClientList"
                  @change="getwarehouse(selectedClient)"
                  outlined
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" md="3" class="pb-0">
                <v-autocomplete
                  v-model="warehouse_id"
                  label="Warehouse"
                  item-text="name"
                  item-value="id"
                  :items="warehouses"
                  outlined
                  v-if="selectedClient"
                  @change="getStores(selectedClient, warehouse_id)"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="3" md="3" class="pb-0" v-if="warehouse_id">
                <v-autocomplete
                  v-model="infor_storer_id"
                  label="Storer Name"
                  item-text="channel_name"
                  item-value="id"
                  :items="stores"
                  outlined
                  @change="callFunc()"
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                sm="3"
                md="3"
                class="pb-0"
                v-if="infor_storer_id"
              >
                <v-text-field v-model="sku" outlined label="SKU"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3" v-if="infor_storer_id">
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(from_date)"
                      label="WMS Created From Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      outlined
                      @click:clear="clearDateInput('this.from_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="from_date"
                    @input="dateMenu = false"
                    :max="getEndDate"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="3" v-if="infor_storer_id">
                <v-menu
                  v-model="dateMenuTo"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(to_date)"
                      label="WMS Created To Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      clearable
                      outlined
                      @click:clear="clearDateInput('this.to_date')"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="to_date"
                    @input="dateMenuTo = false"
                    :max="getEndDate"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-row class="custom-row pl-5 pr-5" v-if="infor_storer_id">
                <v-col
                  cols="12"
                  :sm="
                    userCategory.user_category === 3 ||
                    userCategory.user_category === 6
                      ? 12
                      : 12
                  "
                >
                  <v-btn color="white" @click="clearAll" style="float: right"
                    >Clear</v-btn
                  >
                  <v-btn
                    color="primary"
                    class="success mr-5"
                    @click="searchAll"
                    style="float: right"
                    >Search</v-btn
                  >
                  <v-btn
                    color="info"
                    class="mr-2 ml-3"
                    v-if="
                      checkPermission('app_sku_variant:b2b_sku_list_download')
                    "
                    :loading="downloader"
                    style="float: right"
                    @click="download()"
                    >Download</v-btn
                  >
                </v-col>
              </v-row>
            </div>
            <v-divider class="mb-2"></v-divider>
          </template>
        </template>
        <template v-slot:[`item.ADDDATE`]="{ item }">
          <span v-if="item.ADDDATE">
            {{
              item.ADDDATE | localMomentNew | moment("DD MMM, YYYY hh:mm A")
            }}</span
          >
          <span v-else>--</span>
        </template>
        <template v-slot:[`item.EDITDATE`]="{ item }">
          <span v-if="item.EDITDATE">
            {{
              item.EDITDATE | localMomentNew | moment("DD MMM, YYYY hh:mm A")
            }}</span
          >
          <span v-else>--</span>
        </template>
        <template v-slot:[`item.length_master_unit`]="{ item }">
          <span v-if="item.length_master_unit !== null">
            ({{ item.width_master_unit }} * {{ item.height_master_unit }} *
            {{ item.length_master_unit }})</span
          >
          <span v-else>--{{ item.length_master_unit }}</span>
        </template>
      </v-data-table>
    </v-app>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {},
  created() {
    if (this.$store.getters.user.user_category == 1) {
      this.selectedClient = this.$store.getters.user.id;
      this.getwarehouse(this.$store.getters.user.id);
    }
  },
  computed: {
    ...mapGetters(["userCategory"]),
    getEndDate() {
      var endDate = new Date();
      endDate.setDate(endDate.getDate() + 1);
      endDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
      return endDate.toISOString().split("T")[0]; // Keep only the date part
    },
    _headers() {
      return this.headers.filter((i) => {
        return this.userCategory.user_category !== 3
          ? i.value !== "client_name"
          : true;
      });
    },
  },
  mounted() {
    this.fetchClientList();
  },
  data() {
    return {
      syncloader: false,
      clientLoader: false,
      infor_storer_id: null,
      downloader: false,
      to_date: null,
      dateMenuTo: false,
      dateMenu: false,
      status: null,
      from_date: null,
      options: {},
      stores: [],
      clients: [],
      selectedClient: null,
      total: 0,
      loader: false,
      warehouses: [],
      list: [],
      sku: null,
      headers: [
        {
          text: "Store",
          value: "STORERKEY",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "HS Code",
          value: "hscode",
          class: "body-1 font-weight-bold",
          sortable: false,
        },

        {
          text: "SKU",
          value: "SKU",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Product Type",
          value: "SUSR1",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "DG Class",
          value: "SUSR2",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Description",
          value: "DESCR",
          class: "body-1 font-weight-bold",
          sortable: false,
        },

        {
          text: "Packkey",
          value: "PACKKEY",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Unit (W * H * L) In (Meter)",
          value: "length_master_unit",
          class: "body-1 font-weight-bold",
          sortable: false,
          width: "150px",
        },
        {
          text: "Unit Weight In (KG)",
          value: "SUSR7",
          class: "body-1 font-weight-bold",
          sortable: false,
          width: "130px",
        },
        {
          text: "Case Qty",
          value: "CASE QTY",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Case UOM",
          value: "CASE_UOM",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Cost",
          value: "COST",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Inbound Shelf Life",
          value: "INBOUND_SHELF_LIFE",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Inner Pack Qty",
          value: "INNER PACK QTY",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Inner Pack UOM ",
          value: "INNER_PACK_UOM",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Pallet UOM ",
          value: "PALLET_UOM",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Pallet Qty",
          value: "PALLET QTY",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Master Qty",
          value: "MASTER_QTY",
          class: "body-1 font-weight-bold",
          sortable: false,
        },

        {
          text: "Master UOM",
          value: "MASTER_UOM",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Outbound Shelf Life",
          value: "OUTBOUND_SHELFLIFE",
          class: "body-1 font-weight-bold",
          sortable: false,
        },
        {
          text: "Created At",
          value: "ADDDATE",
          class: "body-1 font-weight-bold",
          sortable: false,
          width: "150px",
        },
        {
          text: "Updated At",
          value: "EDITDATE",
          class: "body-1 font-weight-bold",
          sortable: false,
          width: "150px",
        },
      ],
      warehouse_id: null,
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    options: {
      handler() {
        this.allFilters();
        if (this.warehouse_id !== null && this.warehouse_id !== "")
          this.callFunc();
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions([
      "fetchClient",
      "getInforWarehouseListBB",
      "getWarehouseStores",
      "snackBar",
      "getB2bSKUList",

      "downloadb2bskulist",
    ]),
    clearDateInput(type) {
      if (type == "this.to_date") {
        this.to_date = "";
      } else {
        this.from_date = "";
      }
    },
    getwarehouse(id) {
      this.warehouse_id = "";
      this.infor_storer_id = null;
      this.list = [];
      if (id) {
        this.getInforWarehouseListBB(id).then((response) => {
          this.warehouses = response.data.result;
        });
      }
    },
    getStores() {
      this.infor_storer_id = null;
      this.list = [];
      this.sku = null;
      this.to_date = "";
      this.from_date = null;
      this.status = null;
      let payload = {
        client_id: this.selectedClient,
        warehouse_id: this.warehouse_id,
      };
      if (this.warehouse_id) {
        this.getWarehouseStores(payload).then((res) => {
          this.stores = res.data;
        });
      } else {
        this.stores = [];
      }
    },
    callFunc() {
      if (this.infor_storer_id) {
        this.allFilters();
        this.loader = true;
        this.getB2bSKUList({
          ...this.options,
          ...this.filtersArr,
        })
          .then((res) => {
            this.list = res.data.records;
            this.total = res.data.total;
            this.loader = false;
          })
          .catch(() => {
            this.loader = false;
            this.list = [];
          });
      } else {
        this.list = [];
        this.sku = null;
        this.to_date = "";
        this.from_date = null;
        this.status = null;
      }
    },

    async download() {
      await this.allFilters();

      this.downloader = true;
      this.downloadb2bskulist({
        ...this.selectedClient,
        ...this.filtersArr,
        ...this.options,
        pagination: 0,
      })
        .then((res) => {
          this.fileDownload(res);
          this.downloader = false;
        })
        .catch(() => {
          this.downloader = false;
        });
    },
    clearAll() {
      this.filtersArr = [];
      this.sku = null;
      this.to_date = "";
      this.from_date = null;

      this.status = null;
      this.infor_storer_id = null;
      this.callFunc();
    },
    allFilters() {
      this.orderLoader = true;
      let obj = {
        client_id: this.selectedClient,
        storer_id: this.infor_storer_id,
        warehouse_id: this.warehouse_id,
        sku: this.sku,
        from_date: this.from_date,
        to_date: this.to_date,
      };
      Object.keys(obj).forEach((key) => {
        if (obj[key] === null || obj[key] === undefined || obj[key] === "") {
          delete obj[key];
        }
      });
      this.filtersArr = obj;
    },
    async searchAll() {
      this.list = [];
      this.options.page = 1;
      this.allFilters();
      await this.getB2bSKUList({
        ...this.options,
        ...this.filtersArr,
      })
        .then((res) => {
          this.loader = false;
          this.list = res.data.records;
          this.total = res.data.total;
        })
        .catch(() => {
          this.loader = false;
        });
    },
    fetchClientList() {
      if (this.clients.length) return;
      if (
        this.clients.length === 0 &&
        (this.userCategory.user_category === 3 ||
          this.userCategory.user_category === 6)
      ) {
        this.clientLoader = true;
        this.fetchClient({
          fields: "id,name",
          pagination: 0,
          service: "b2b_fulfillment",
          active: "True",
        })
          .then((res) => {
            this.clientLoader = false;
            this.clients = res.data;
          })
          .catch(() => {
            this.clientLoader = false;
          });
      }
    },
  },
};
</script>
<style scoped>
.file-padding {
  padding-right: 72px;
}
.custom-row {
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 5px 20px 5px 5px !important;
}
.v-select:not(.v-text-field--single-line):not(.v-text-field--outlined)
  .v-select__slot
  > input {
  align-self: flex-end;
}
</style>
